/**
 * Rate structure codes matching the backend `RateStructure` enum in
 * `Tower.SecurityMaster.Domain.Enums.ChildEntityEnums`.
 * These are the string values sent in `RateStructures.Values` on
 * `QuoteSearchRequest` / `QuoteRequestSearchRequest`.
 */
export type RateStructureCode =
  | "Fixed"
  | "Zero"
  | "Variable"
  | "Auction"
  | "Floating"
  | "Step"
  | "Convertible";

export interface RateStructureOption {
  code: RateStructureCode;
  label: string;
}

export const RATE_STRUCTURE_OPTIONS: readonly RateStructureOption[] = [
  { code: "Fixed", label: "Fixed" },
  { code: "Zero", label: "Zero Coupon" },
  { code: "Variable", label: "Variable Rate / VRDO" },
  { code: "Auction", label: "Auction Rate" },
  { code: "Floating", label: "Floating - Index Based" },
  { code: "Step", label: "Step Up / Step Down" },
  { code: "Convertible", label: "Convertible / Hybrid Rate Mode" },
] as const;

const CODE_SET = new Set<string>(RATE_STRUCTURE_OPTIONS.map((o) => o.code));

export function isRateStructureCode(value: string): value is RateStructureCode {
  return CODE_SET.has(value);
}

const LABEL_BY_CODE = Object.fromEntries(
  RATE_STRUCTURE_OPTIONS.map((o) => [o.code, o.label]),
) as Record<RateStructureCode, string>;

export function rateStructureLabel(code: RateStructureCode): string {
  return LABEL_BY_CODE[code];
}
